import { render } from "./TestProductList.vue?vue&type=template&id=6e08d9f4&scoped=true"
import script from "./TestProductList.vue?vue&type=script&lang=js"
export * from "./TestProductList.vue?vue&type=script&lang=js"

import "./TestProductList.vue?vue&type=style&index=0&id=6e08d9f4&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e08d9f4"]])

export default __exports__